import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { AppSettings } from '../../../sharedcomponents/_common/constants/app.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
@Injectable()
export class ValidateTMService {
  trustedDashboardUrl: SafeUrl;
  constructor(private http: Http, private router: Router, private sanitizer: DomSanitizer) {}

  returnTMSession(sessionId: string) {
    const url: string = AppSettings.tmService + sessionId;
    let headers = new Headers({});
    headers = new Headers({ LanguageCode: 'en' });
    headers.append('Access-Control-Allow-Credentials', 'true');
    const options = new RequestOptions({ headers: headers });
    return this.http.get(url).map((res: Response) => {
      if (res) {
        return [{ status: res.status, json: res }];
      }
    });
  }

  readtitlefromjson() {
    let url: string = AppSettings.pagetitleFilePath;
    return this.http.get(url).map((res: Response) => {
      if (res) {
        return [{ status: res.status, json: res }];
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/commonservice/TmValidation/tmvalidation.service.ts